import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { IAppError } from "@comunicare/comunicare-interfaces";
import { Subject } from "rxjs";
import { HealthcareserviceService } from "./healthcareservice.service";
import { OrganizationsService } from "./organizations.service";
import { SessionService } from "./session.service";
import { UserService } from "./user.service";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  public catchedError = new Subject<IAppError>();

  constructor(private injector: Injector) {}

  public handleError(error: IAppError): void {
    const sessionService = this.injector.get(SessionService);
    const userService = this.injector.get(UserService);
    const healthcareService = this.injector.get(HealthcareserviceService);
    const organizationService = this.injector.get(OrganizationsService);
    // Invalid token, disconnect and go to login page. Same in Case of error 404
    if (error.code === 403 || error.code === 0) {
      // this.sessionService.redirectUrl = this.router.url;
      organizationService.clear();
      healthcareService.clear();
      userService.clear();
      sessionService.clear();
      // window.location.reload();
      window.location.href = "/";
    }

    this.catchedError.next(error);
  }
}
